
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateCostCentreDtoFormGroup() {
return new FormGroup({
    number: new FormControl<string | undefined>('', [Validators.maxLength(30)]),
    name: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    active: new FormControl<boolean | undefined>(undefined),
    selectable: new FormControl<boolean | undefined>(undefined),
})
;
}
      